Vue = require 'vue'

# eslint-disable no-new
new Vue
  el: 'body'
  components:
    app: require './App'



/** WEBPACK FOOTER **
 ** ./src/main.coffee
 **/